// extracted by mini-css-extract-plugin
export default {"container":"oAYeit4x","buttons":"Xw7VtigI","button":"f9uDJdvE","button_purple":"DSist0sY","buttonPurple":"DSist0sY","buttonIcon":"iQddp8Ac"};